import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals, Constants, Colors } from 'utils';
import { Table, Pagination, Tooltip, Input, DatePicker, Select, Modal } from 'components';
import { CleanIcon, AddIcon, EditIcon, TrashIcon } from 'assets/icons';
import { PaymentService } from 'services';
import moment from 'moment';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const INITIAL_STATE = {
	search: '',
	since: '',
	until: ''
}

class PaymentReport extends React.Component<Props> {

	timer: any = undefined;

	state = {
		header: [
			'Fecha de Pago',
			'Usuario',
			'Monto',
			'Método de Pago',
			'Plan',
			'Fecha Vencimiento',
			'Referencia'			
		],
		form: INITIAL_STATE,
		data: [],
		page: 1,
		last_page: 1,
		years: []
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Reporte de Pagos',
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});

		let years: any = [...this.state.years];

		for (let i = parseInt(moment().format('YYYY')); i > 2000; i--) {
			years.push({
				value: i,
				label: i
			});
		}

		this.setState({
			years
		});

		this.load();
	}

	load = async (withoutLoading: boolean = false,callback = () => {}) => {
		const res: any = await PaymentService.admin.get({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
			since: moment(this.state.form.since).isValid() ? moment(this.state.form.since).format('YYYY-MM-DD') : '',
			until: moment(this.state.form.until).isValid() ? moment(this.state.form.until).format('YYYY-MM-DD') : ''
		});
		this.setState({
			data: res.payments.rows,
			last_page: res.payments.count
		});
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	reset = () => {
		this.setState({
			form: INITIAL_STATE,
			page: 1
		},() => this.load(true));
	}

	render() {
		return (
			<div id="report-payments">
				<div className="row row-filter">
					<div className="col-md-12">
						<div className="row">
							<div className="col-md-8 row">
								<div className="col-md-4">
									<Input
										value={ this.state.form.search }
										name="search"
										placeholder="Buscar"
										label="Buscar por usuario"
										className="input-table"
										onSubmit={ () => this.load() }
										onChange={ (e: any) => {
											clearTimeout(this.timer);
											this.timer = setTimeout(() => {
												this.load(true);
											},1000);
											this.change(e); 
										} } />
								</div>
								<div className="col-md-4">
									<DatePicker
										label="Desde"
										onChange={ (text: string) => {
											this.change({
												target: {
													value: text,
													name: 'since'
												}
											},() => this.load(true));
										} }
										value={ this.state.form.since }
									/>
								</div>
								<div className="col-md-4">
									<DatePicker
										label="Hasta"
										onChange={ (text: string) => {
											this.change({
												target: {
													value: text,
													name: 'until'
												}
											},() => this.load(true));
										} }
										value={ this.state.form.until }
									/>
								</div>
							</div>
							<div className="col-md-1">
								{
									this.state.form != INITIAL_STATE && (
										<button className="btn btn-clean" onClick={ () => this.reset() }>
											<img src={ CleanIcon } />
										</button>
									)
								}
							</div>
						</div>
					</div>
				</div>

				<Table title="Reporte de Pagos" data={ this.state.data.length } header={ this.state.header }>
					{ this.state.data.map((i: any,index: number) => {
						return (
							<tr key={ index }>
								<td>{ moment(i.created_at).format('DD/MM/YYYY') }</td>
								<td>{ i.user?.name + ' ' + i?.user?.lastname }</td>
								<td>{ Globals.formatMiles(i.total * i.conversion,true,'Bs.') }</td>
								<td>{ i.payment_method?.name || '-' }</td>
								<td>{ i.plan_user?.plan?.name || '-' }</td>
								<td>{ moment(i.plan_user?.expiration_date).format('DD/MM/YYYY') }</td>
								<td>{ i.reference }</td>
							</tr>
						)
					}) }
				</Table>

				<Pagination 
					pages={ this.state.last_page } 
					active={ this.state.page }
					onChange={ async (page: number) => {
						await this.setState({
							page: page
						});
						this.load();
					} } />
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(PaymentReport);